import { Injectable, isDevMode } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DevModeService {

  constructor() { }

  isDevMode(){
    return ((window as any).location.host.indexOf('localhost') >= 0);
  }
}
